import useI18n from '@/shared/hooks/usei18n'
import { Tooltip } from '@/common'
import { TriangleExclamationIcon, CheckCircleIcon } from '@/common/components/icons'
import { ImportedGoodEligibilityResult } from '@/shared/utils/importedGoodEligibility'

export default function StatusCell({
  eligibility
}: {
  eligibility: ImportedGoodEligibilityResult
}) {
  const { t } = useI18n()
  const isComplete = eligibility.status === 'COMPLETE'

  // Map field names to user-friendly labels
  const getFieldLabel = (fieldName: string): string => {
    const fieldLabels: Record<string, string> = {
      cnCode: t('cbamReporting:cbamReportDetails.reportedGoods.missingFields.cnCode'),
      netMassInTonnes: t(
        'cbamReporting:cbamReportDetails.reportedGoods.missingFields.netMassInTonnes'
      ),
      country: t('cbamReporting:cbamReportDetails.reportedGoods.missingFields.country'),
      importerId: t('cbamReporting:cbamReportDetails.reportedGoods.missingFields.importer'),
      partnershipId: t('cbamReporting:cbamReportDetails.reportedGoods.missingFields.supplier'),
      installationId: t('cbamReporting:cbamReportDetails.reportedGoods.missingFields.installation'),
      supplierEmissionsReportId: t(
        'cbamReporting:cbamReportDetails.reportedGoods.missingFields.supplierEmissionsReport'
      ),
      requestedCustomsProcedure: t(
        'cbamReporting:cbamReportDetails.reportedGoods.missingFields.customsProcedure'
      )
    }
    return fieldLabels[fieldName] || fieldName
  }

  const missingFieldsLabels = eligibility.missingFields.map(getFieldLabel)

  const tooltipContent = isComplete
    ? t('cbamReporting:cbamReportDetails.reportedGoods.statusTooltip.complete')
    : t('cbamReporting:cbamReportDetails.reportedGoods.statusTooltip.incomplete', {
        missingFields: missingFieldsLabels.join(', ')
      })

  return (
    <Tooltip content={tooltipContent} position="top">
      <div className="flex items-center justify-center">
        {isComplete ? (
          <CheckCircleIcon className="size-6 text-green-500" />
        ) : (
          <TriangleExclamationIcon className="size-6 text-yellow-400" />
        )}
      </div>
    </Tooltip>
  )
}
